export default __webpack_public_path__ + "static/media/brutalenragingstrike1.69f3d4d9.png";